import React from 'react';
import { Outlet } from 'react-router-dom';

import { useDesignVersion } from '../../context/useDesignVersion';
import { useIsAdmin } from '../../hooks/useIsAdmin';
import V2AdminLayout from '../../v2/components/V2AdminLayout';

const AdminRouteShell: React.FC = () => {
  const { user, initialLoad } = useIsAdmin();
  const { isModernDesign } = useDesignVersion();

  if (!initialLoad || !user?.isAdmin) {
    return null;
  }

  if (isModernDesign) {
    return <V2AdminLayout />;
  }

  return <Outlet />;
};

export default AdminRouteShell;
